import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import ProductDetailPage from './ProductDetailPage';
import WishlistPage from './WishlistPage';
import PromoBanner from './PromoBanner';

function App() {
  return (
    <>
      <PromoBanner />
      <Routes>
        <Route path="/product" element={<Layout />} />
        <Route path="/product/:slug" element={<ProductDetailPage />} />
        <Route path="/seznam-prani" element={<WishlistPage />} />
      </Routes>
    </>
  );
}

export default App;
